import type {
  InitializeProgressBar,
  SetCurrentStep,
  SetProgressBarCurrentStep,
  StepItems,
} from '@avalara/types/progress-bar';

import type { SharedState } from '@avalara/types/index';

export const initializeProgressBar = (steps: Array<StepItems>): InitializeProgressBar => ({
  type: 'INITIALIZE_PROGRESS_BAR',
  steps,
});

export const setCurrentStep = (index: number): SetCurrentStep => ({
  type: 'SET_CURRENT_STEP',
  index,
});

export const setProgressBarCurrentStep = (label: string): SetProgressBarCurrentStep => ({
  type: 'SET_PROGRESS_BAR_CURRENT_STEP',
  label,
});

type Action = SetCurrentStep;

export type GetState = () => SharedState;
export type Dispatchables = Action;
export type Dispatch = (action: Dispatchables) => void;
